import { render, staticRenderFns } from "./verify_otp.vue?vue&type=template&id=3f86b1de&scoped=true&"
import script from "./verify_otp.vue?vue&type=script&lang=js&"
export * from "./verify_otp.vue?vue&type=script&lang=js&"
import style0 from "./verify_otp.vue?vue&type=style&index=0&id=3f86b1de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86b1de",
  null
  
)

export default component.exports